import React, { useState, useEffect } from "react";
import {
    useStripe,
    useElements,
    CardElement,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
} from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
import { membershipValues } from "../../feature/authSlice";
import { useNavigate } from "react-router-dom";
import {
    validateCoupon,
    processPayment,
    confirmPayment,
} from "../../api/apiCall";
import { setIsLoading } from "../../actions";
import { FaLock, FaCoins, FaChevronLeft } from "react-icons/fa";
import { FormattedNumber } from "react-intl";
import { LiaKeySolid } from "react-icons/lia";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { BsEnvelope } from "react-icons/bs";

const useStripePayment = () => {
    const auth = useSelector((state) => state.auth);
    const userData = JSON.parse(localStorage.getItem("user"));
    const aToken = localStorage.getItem("token");

    const stripe = useStripe();
    const elements = useElements();
    const [accessKeyUsed, setAccessKeyUsed] = useState("");
    const [accessKeyDiscount, setAccessKeyDiscount] = useState(0);

    const [membershipCountryValues, setMembershipCountryValues] = useState({
        currencyName: "USD",
        currencySymbol: "$",
        membershipFeeForDisplay: 195,
        membershipFeeForComputation: 195,
        membershipRenewalFee: "135",
        updated: false,
    });

    const [coupon, setCoupon] = useState("");
    const [couponUsedCode, setCouponUsedCode] = useState("");
    const [couponValue, setCouponValue] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [paymentIntentId, setPaymentIntentId] = useState("");
    const [paymentMethod, setPaymentMethod] = useState({});
    const [cardHolder, setCardHolder] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [couponStates, setCouponStates] = useState({
        loading: false,
        success: false,
        error: false,
        message: "",
    });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleMembershipValues = async () => {
        const { id } = userData || { id: 0 };

        // await dispatch(membershipValues({ id })).then(data => {
        //   if (data?.payload) {
        //     const x = data?.payload;

        //     setMembershipCountryValues({
        //       currencyName: x.currency_name,
        //       currencySymbol: x.currency_symbol,
        //       membershipFee: x.membership_fee,
        //       membershipRenewalFee: x.membership_renewal_fee,
        //       membershipFeeForComputation: x.membership_fee,
        //       updated: true,
        //     });
        //   }
        // });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (
            couponUsedCode &&
            membershipCountryValues.membershipFeeForComputation === 0
        ) {
            submitTotallyFree();
        }
        if (!couponUsedCode) {
            submitUsingCard();
        }
        if (
            couponUsedCode &&
            membershipCountryValues.membershipFeeForComputation > 0
        ) {
            submitUsingCard();
        }
    };

    const submitUsingCard = async () => {
        dispatch(setIsLoading(true));

        if (!stripe || !elements) {
            return;
        }

        const cardNumberElement = elements.getElement(CardNumberElement);
        const cardExpiryElement = elements.getElement(CardExpiryElement);
        const cardCvcElement = elements.getElement(CardCvcElement);

        if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
            setErrorMessage("Please complete all payment fields");
            dispatch(setIsLoading(false));
            return;
        }

        if (!cardHolder) {
            setErrorMessage("Please enter card holder's name");
            dispatch(setIsLoading(false));
            return;
        }

        if (!zipCode) {
            setErrorMessage("Please enter your ZIP code");
            dispatch(setIsLoading(false));
            return;
        }

        setErrorMessage("");

        try {
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: cardNumberElement,
                billing_details: {
                    name: cardHolder,
                },
            });

            if (error) {
                setErrorMessage(error.message);
            } else {
                const { id } = userData || { id: 0 };
                const data = {
                    id: id,
                    token: aToken,
                    payloads: {
                        cardHolder: cardHolder,
                        paymentMethod: paymentMethod.id,
                        coupon: accessKeyUsed || "",
                        membershipFee: membershipCountryValues.membershipFee,
                        amount:
                            membershipCountryValues.membershipFeeForComputation -
                            membershipCountryValues.membershipFeeForComputation *
                            accessKeyDiscount,
                    },
                };

                const response = await processPayment(data);
                console.log("Process Payment: ", response);

                if (response?.data?.clientSecret) {
                    let udata = JSON.parse(localStorage.getItem("user"));

                    if (udata) {
                        udata.is_paid = 1;
                        localStorage.setItem("user", JSON.stringify(udata));
                    } else {
                        console.error("User data not found in localStorage");
                    }

                    navigate("/thankyou");
                } else {
                    throw new Error(
                        "Payment not successful. Please check your details and try again."
                    );
                }
            }
        } catch (error) {
            console.error("Error processing payment: ", error);
            if (error.response?.status === 402) {
                setClientSecret(error.response?.data?.clientSecret);
                setPaymentIntentId(error.response?.data?.payment_intent_id);
                setShowConfirmation(true);
            }
            setErrorMessage(error.response?.data?.error);
        } finally {
            dispatch(setIsLoading(false));
        }
    };

    const submitTotallyFree = async () => {
        dispatch(setIsLoading(true));
        setErrorMessage("");

        try {
            const { id } = userData || { id: 0 };
            const data = {
                id: id,
                token: aToken,
                payloads: {
                    coupon: accessKeyUsed,
                },
            };

            const response = await processPayment(data);
            console.log("Process Payment: ", response);

            if (response.status === 200) {
                let udata = JSON.parse(localStorage.getItem("user"));

                if (udata) {
                    udata.is_paid = 1;
                    localStorage.setItem("user", JSON.stringify(udata));
                } else {
                    console.error("User data not found in localStorage");
                }

                navigate("/thankyou");
            } else {
                throw new Error(
                    "Payment not successful. Please check your details and try again."
                );
            }
        } catch (error) {
            console.error("Error processing payment: ", error);
            setErrorMessage(error.response?.data?.error);
        } finally {
            dispatch(setIsLoading(false));
        }
    };

    const handleValidateCoupon = async () => {
        setCouponStates((prevState) => ({
            ...prevState,
            loading: true,
        }));

        try {
            if (coupon.trim() !== "") {
                let data = {
                    token: aToken,
                    coupon: coupon,
                };

                const response = await validateCoupon(data);
                console.log(response);

                if (response.status === 200) {
                    setCouponValue(response?.data?.data.amount || 0);
                    setCouponUsedCode(coupon);
                    setMembershipCountryValues((prev) => ({
                        ...prev,
                        membershipFeeForComputation:
                            prev.membershipFeeForComputation - response.data.data.amount,
                    }));
                    setCouponStates((prevState) => ({
                        ...prevState,
                        success: true,
                        message: response?.data?.message,
                    }));
                } else {
                    setCouponStates((prevState) => ({
                        ...prevState,
                        error: true,
                        message: response?.data?.message,
                    }));
                }
            }
        } catch (error) {
            console.error("Error validating coupon: ", error);
            setCouponStates((prevState) => ({
                ...prevState,
                error: true,
                message: error?.response?.data?.message,
            }));
        } finally {
            setCouponStates((prevState) => ({
                ...prevState,
                loading: false,
            }));
        }
    };

    const handlConfirmPayment = async () => {
        dispatch(setIsLoading(true));
        try {
            if (membershipCountryValues.membershipFeeForComputation === 0) {
                userData.is_paid = 1;
                localStorage.setItem("user", JSON.stringify(userData));
                setShowConfirmation(false);
                console.log("User Info: ", localStorage.getItem("user"));
                navigate("/thankyou");
            }

            const confirmResult = await stripe.confirmCardPayment(clientSecret, {
                payment_method: paymentMethod.id,
            });

            console.log(confirmResult);

            if (confirmResult.error) {
                setErrorMessage(confirmResult.error.message);
            } else if (
                confirmResult.paymentIntent &&
                confirmResult.paymentIntent.status === "succeeded"
            ) {
                let data = {
                    id: userData.id,
                    token: aToken,
                    payloads: {
                        payment_intent_id: paymentIntentId,
                    },
                };

                const response = await confirmPayment(data);
                if (response.status === 200) {
                    userData.is_paid = 1;
                    localStorage.setItem("user", JSON.stringify(userData));
                    setShowConfirmation(false);
                    console.log("User Info: ", localStorage.getItem("user"));
                    navigate("/thankyou");
                }
            }
        } catch (error) {
            console.error("Error confirming payment: ", error);
        } finally {
            dispatch(setIsLoading(false));
        }
    };

    const stringToFloat = async (strParam) => {
        if (strParam) {
            return parseFloat(strParam.replace(/,/g, ""));
        } else {
            return 0;
        }
    };

    const stringToInt = async (strParam) => {
        if (strParam) {
            return parseInt(strParam.replace(/,/g, ""));
        } else {
            return 0;
        }
    };

    return {
        membershipCountryValues,
        coupon,
        setCoupon,
        couponValue,
        setCouponValue,
        setAccessKeyUsed,
        setAccessKeyDiscount,
        errorMessage,
        handleSubmit,
        handleValidateCoupon,
        handleMembershipValues,
        couponStates,
        showConfirmation,
        setShowConfirmation,
        handlConfirmPayment,
        cardHolder,
        setCardHolder,
        zipCode,
        setZipCode,
    };
};

const StripePayment = ({ accessKeyUsed, accessKeyDiscount }) => {
    const [showCardElement, setShowCardElement] = useState(false);
    const [cardType, setCardType] = useState("");
    const [isFading, setIsFading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const auth = useSelector((state) => state.auth);
    const {
        handleSubmit,
        errorMessage,
        coupon,
        couponValue,
        setCoupon,
        setAccessKeyUsed,
        setAccessKeyDiscount,
        handleValidateCoupon,
        handleMembershipValues,
        membershipCountryValues,
        couponStates,
        showConfirmation,
        setShowConfirmation,
        handlConfirmPayment,
        cardHolder,
        setCardHolder,
        zipCode,
        setZipCode,
    } = useStripePayment();

    useEffect(() => {
        setAccessKeyUsed(accessKeyUsed);
        setAccessKeyDiscount(accessKeyDiscount);
        handleAddPaymentMethod();
    }, []);

    const handleAddPaymentMethod = () => {
        setShowCardElement(true);
    };

    const CARD_ELEMENT_OPTIONS = {
        style: {
            base: {
                iconColor: "#666EE8",
                color: "#31325F",
                fontWeight: 400,
                fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
                fontSize: "16px",
                "::placeholder": {
                    color: "#CFD7E0",
                },
            },
            invalid: {
                iconColor: "#E25950",
                color: "#E25950",
            },
        },
    };

    useEffect(() => {
        if (!membershipCountryValues.updated) {
            handleMembershipValues();
        }
    }, [membershipCountryValues.updated, handleMembershipValues]);

    useEffect(() => {
        setIsFading(true);

        const tm = setTimeout(() => {
            setIsFading(false);
            setCoupon("");
        }, 3000);

        return () => {
            clearTimeout(tm);
        };
    }, [auth.coupon.error, setCoupon]);

    const handleCardChange = (event) => {
        const { brand } = event;

        let cardBrand = "";
        switch (brand) {
            case "stripe":
                cardBrand = "Stripe";
                break;
            case "visa":
                cardBrand = "Visa";
                break;
            case "mastercard":
                cardBrand = "Mastercard";
                break;
            case "amex":
                cardBrand = "American Express";
                break;
            case "discover":
                cardBrand = "Discover";
                break;
            case "jcb":
                cardBrand = "JCB";
                break;
            case "diners":
                cardBrand = "Diners Club";
                break;
            case "unionpay":
                cardBrand = "UnionPay";
                break;
            default:
                cardBrand = "Unknown Card Type";
        }

        if (cardBrand) {
            setCardType(cardBrand);
        }
    };

    const elements = useElements();
    const isPayNowDisabled = !(
        cardHolder && zipCode &&
        elements?.getElement(CardNumberElement) &&
        elements?.getElement(CardExpiryElement) &&
        elements?.getElement(CardCvcElement)
    );

    return (
        <div className="min-h-screen overflow-hidden">
            <div className="flex flex-col mx-auto mt-8 max-w-[900px] max-md:px-5 bg-white rounded-lg border border-gray-200 max-md:mx-5">
                <div className="flex flex-col lg:flex-row bg-white rounded-2xl">
                    <div className="px-4 py-6 lg:px-8 lg:py-6 lg:w-[40%] max-md:px-0">
                        <div className="flex items-center font-bold text-[#1c3775] text-lg lg:text-xl">
                            {cardType ? (
                                <button
                                    className="flex items-center gap-2 text-lg lg:text-xl"
                                    onClick={() => setCardType(null)}
                                >
                                    <FaChevronLeft />
                                    Back
                                </button>
                            ) : (
                                <button className="flex items-center gap-2 text-lg lg:text-xl" onClick={() => navigate(-1)}>
                                    <FaChevronLeft />
                                    Payment Method
                                </button>
                            )}
                        </div>

                        <div className="h-full w-full flex flex-col items-center justify-start">
                            {cardType ? (
                                <div className="my-4">
                                    {/* Stripe image */}
                                    {cardType === "Stripe" && (
                                        <svg
                                            width="190"
                                            height="94"
                                            viewBox="0 0 75 41"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                x="0.5"
                                                y="1"
                                                width="73.0241"
                                                height="39"
                                                rx="3.5"
                                                stroke="none"
                                            />
                                            <g clip-path="url(#clip0_5104_24596)">
                                                <path
                                                    d="M65.7223 20.8454C65.7223 16.7622 63.7444 13.5402 59.9643 13.5402C56.1681 13.5402 53.8713 16.7623 53.8713 20.8136C53.8713 25.6145 56.5829 28.0389 60.4746 28.0389C62.3727 28.0389 63.8083 27.6083 64.8929 27.0022V23.8121C63.8084 24.3545 62.5642 24.6895 60.9851 24.6895C59.4379 24.6895 58.0662 24.1471 57.8908 22.265H65.6905C65.6905 22.0575 65.7223 21.2282 65.7223 20.8454ZM57.8429 19.3302C57.8429 17.5278 58.9436 16.7781 59.9484 16.7781C60.9213 16.7781 61.9581 17.5278 61.9581 19.3302H57.8429ZM47.7147 13.5402C46.1514 13.5402 45.1466 14.2739 44.5884 14.7844L44.3809 13.7955H40.872V32.3932L44.8595 31.548L44.8755 27.0341C45.4497 27.4488 46.295 28.0389 47.6987 28.0389C50.5538 28.0389 53.1536 25.7421 53.1536 20.6859C53.1377 16.0603 50.5059 13.5402 47.7146 13.5402M46.7575 24.5299C45.8164 24.5299 45.2581 24.195 44.8754 23.7803L44.8594 17.8627C45.2741 17.4002 45.8483 17.0812 46.7575 17.0812C48.2089 17.0812 49.2138 18.7081 49.2138 20.7975C49.2138 22.9349 48.2249 24.5299 46.7575 24.5299ZM35.3851 12.5992L39.3886 11.7379V8.5L35.3851 9.34538V12.5992ZM35.3851 13.8114H39.3886V27.7677H35.3851V13.8114ZM31.0946 14.9917L30.8393 13.8114H27.3941V27.7677H31.3817V18.3094C32.3226 17.0812 33.9177 17.3045 34.4122 17.4799V13.8114C33.9018 13.62 32.0356 13.269 31.0946 14.9917ZM23.1194 10.3502L19.2276 11.1796L19.2117 23.9557C19.2117 26.3164 20.9822 28.0548 23.3428 28.0548C24.6507 28.0548 25.6077 27.8156 26.134 27.5285V24.2907C25.6237 24.498 23.1035 25.2317 23.1035 22.8711V17.2087H26.134V13.8114H23.1035L23.1194 10.3502ZM12.3371 17.8627C12.3371 17.2407 12.8475 17.0014 13.693 17.0014C14.9051 17.0014 16.4363 17.3683 17.6485 18.0223V14.2739C16.3247 13.7476 15.0168 13.5402 13.693 13.5402C10.455 13.5402 8.30176 15.231 8.30176 18.0542C8.30176 22.4563 14.3628 21.7546 14.3628 23.6527C14.3628 24.3863 13.7249 24.6256 12.8316 24.6256C11.5078 24.6256 9.81701 24.0833 8.47716 23.3496V27.1458C9.96056 27.7838 11.4599 28.0548 12.8316 28.0548C16.1492 28.0548 18.4301 26.4121 18.4301 23.557C18.4142 18.8039 12.3371 19.6491 12.3371 17.8627Z"
                                                    fill="#635BFF"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5104_24596">
                                                    <rect
                                                        width="57.4206"
                                                        height="24"
                                                        fill="white"
                                                        transform="translate(8.30176 8.5)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    )}

                                    {/* Visa */}
                                    {cardType === "Visa" && (
                                        <svg
                                            width="200"
                                            height="104"
                                            viewBox="0 0 75 41"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                x="0.524414"
                                                y="1"
                                                width="73.0241"
                                                height="39"
                                                rx="3.5"
                                                stroke="none"
                                            />
                                            <g clip-path="url(#clip0_5104_24599)">
                                                <path
                                                    d="M37.7575 17.7761C37.7336 19.8573 39.4413 21.0186 40.7277 21.7092C42.0494 22.4176 42.4933 22.8719 42.4881 23.5055C42.4783 24.4751 41.4338 24.9031 40.4565 24.9197C38.7514 24.9488 37.76 24.4126 36.9718 24.0071L36.3576 27.1731C37.1484 27.5745 38.6126 27.9246 40.131 27.9399C43.6953 27.9399 46.0271 26.0019 46.0397 22.997C46.0537 19.1834 41.2511 18.9723 41.2839 17.2677C41.2952 16.7508 41.7429 16.1993 42.724 16.059C43.2096 15.9882 44.5502 15.934 46.0701 16.7049L46.6666 13.6417C45.8492 13.3139 44.7987 12.9999 43.4908 12.9999C40.1361 12.9999 37.7765 14.9644 37.7575 17.7761ZM52.3986 13.2638C51.7478 13.2638 51.1993 13.682 50.9545 14.3237L45.8632 27.7149H49.4248L50.1336 25.5573H54.4858L54.897 27.7149H58.0361L55.2968 13.2638H52.3986ZM52.8969 17.1676L53.9247 22.5942H51.1097L52.8969 17.1676ZM33.4392 13.264L30.6318 27.7148H34.0257L36.8319 13.2636L33.4392 13.264ZM28.4184 13.264L24.8858 23.0998L23.4568 14.7365C23.2892 13.8029 22.627 13.2638 21.8917 13.2638H16.117L16.0361 13.6834C17.2216 13.9668 18.5686 14.4239 19.3846 14.9129C19.8841 15.2116 20.0265 15.4728 20.1905 16.1827L22.8971 27.7149H26.4836L31.9824 13.2638L28.4184 13.264Z"
                                                    fill="url(#paint0_linear_5104_24599)"
                                                />
                                            </g>
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_5104_24599"
                                                    x1="1946.94"
                                                    y1="57.9096"
                                                    x2="1994.57"
                                                    y2="-1476.19"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stop-color="#222357" />
                                                    <stop offset="1" stop-color="#254AA5" />
                                                </linearGradient>
                                                <clipPath id="clip0_5104_24599">
                                                    <rect
                                                        width="42"
                                                        height="15"
                                                        fill="white"
                                                        transform="translate(16.0361 13)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    )}

                                    {/* Master */}
                                    {cardType === "Mastercard" && (
                                        <svg
                                            width="200"
                                            height="104"
                                            viewBox="0 0 75 41"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect
                                                x="0.547852"
                                                y="1"
                                                width="73.0241"
                                                height="39"
                                                rx="3.5"
                                                stroke="none"
                                            />
                                            <g clip-path="url(#clip0_5104_24602)">
                                                <path
                                                    d="M27.2364 32.3805V30.7921C27.2364 30.183 26.8656 29.786 26.2302 29.786C25.9125 29.786 25.5683 29.8919 25.33 30.2361C25.1447 29.9448 24.88 29.786 24.4829 29.786C24.218 29.786 23.9534 29.8654 23.7415 30.1566V29.839H23.1855V32.3805H23.7415V30.9773C23.7415 30.5274 23.9798 30.3155 24.3506 30.3155C24.7211 30.3155 24.9066 30.5538 24.9066 30.9773V32.3805H25.4625V30.9773C25.4625 30.5274 25.7271 30.3155 26.0713 30.3155C26.4421 30.3155 26.6273 30.5538 26.6273 30.9773V32.3805H27.2364ZM35.47 29.839H34.57V29.0712H34.014V29.839H33.511V30.3419H34.0139V31.5069C34.0139 32.0894 34.2522 32.4335 34.8877 32.4335C35.126 32.4335 35.3906 32.3541 35.5761 32.2482L35.4171 31.7716C35.2583 31.8775 35.073 31.904 34.9406 31.904C34.6759 31.904 34.57 31.7452 34.57 31.4804V30.3419H35.47V29.839ZM40.1827 29.7859C39.8651 29.7859 39.6533 29.9448 39.5209 30.1566V29.839H38.9649V32.3805H39.5209V30.9509C39.5209 30.5274 39.7061 30.289 40.0503 30.289C40.1562 30.289 40.2886 30.3156 40.3945 30.342L40.5533 29.8125C40.4475 29.786 40.2886 29.786 40.1827 29.786M33.0609 30.0509C32.796 29.8655 32.4254 29.7861 32.0283 29.7861C31.3929 29.7861 30.9694 30.1038 30.9694 30.6068C30.9694 31.0305 31.2871 31.2687 31.843 31.3482L32.1078 31.3747C32.399 31.4275 32.5578 31.507 32.5578 31.6394C32.5578 31.8247 32.3461 31.9571 31.9753 31.9571C31.6046 31.9571 31.3135 31.8247 31.1281 31.6924L30.8634 32.1159C31.1546 32.3277 31.5518 32.4336 31.9488 32.4336C32.6902 32.4336 33.1138 32.0895 33.1138 31.6129C33.1138 31.1628 32.7696 30.9245 32.2401 30.8451L31.9753 30.8186C31.737 30.7921 31.5518 30.7393 31.5518 30.5804C31.5518 30.3951 31.737 30.2892 32.0283 30.2892C32.3461 30.2892 32.6637 30.4215 32.8226 30.5009L33.0609 30.0509ZM47.8342 29.7861C47.5164 29.7861 47.3046 29.945 47.1722 30.1567V29.8391H46.6162V32.3807H47.1722V30.951C47.1722 30.5275 47.3575 30.2892 47.7016 30.2892C47.8076 30.2892 47.94 30.3157 48.0459 30.3421L48.2048 29.8127C48.0989 29.7861 47.94 29.7861 47.8342 29.7861ZM40.7387 31.1099C40.7387 31.8776 41.2682 32.4336 42.089 32.4336C42.4596 32.4336 42.7243 32.3543 42.989 32.1425L42.7243 31.6924C42.5125 31.8512 42.3008 31.9306 42.0625 31.9306C41.6124 31.9306 41.2947 31.6129 41.2947 31.1099C41.2947 30.6334 41.6124 30.3156 42.0625 30.2892C42.3008 30.2892 42.5125 30.3685 42.7243 30.5275L42.989 30.0774C42.7243 29.8655 42.4596 29.7861 42.089 29.7861C41.2682 29.7861 40.7387 30.3421 40.7387 31.1099ZM45.875 31.1099V29.8391H45.319V30.1567C45.1336 29.9186 44.8689 29.7861 44.5247 29.7861C43.8099 29.7861 43.2539 30.3421 43.2539 31.1099C43.2539 31.8776 43.8099 32.4336 44.5247 32.4336C44.8953 32.4336 45.1601 32.3013 45.319 32.063V32.3807H45.875V31.1099ZM43.8363 31.1099C43.8363 30.6598 44.1275 30.2892 44.604 30.2892C45.0541 30.2892 45.3719 30.6334 45.3719 31.1099C45.3719 31.56 45.0541 31.9306 44.604 31.9306C44.1275 31.904 43.8363 31.56 43.8363 31.1099ZM37.1911 29.7861C36.4497 29.7861 35.9201 30.3156 35.9201 31.1099C35.9201 31.9042 36.4496 32.4336 37.2175 32.4336C37.5881 32.4336 37.9588 32.3277 38.2501 32.0895L37.9852 31.6924C37.7734 31.8512 37.5087 31.9571 37.244 31.9571C36.8998 31.9571 36.5556 31.7983 36.4761 31.3481H38.356V31.1364C38.3825 30.3156 37.906 29.7861 37.1911 29.7861ZM37.1909 30.2626C37.535 30.2626 37.7734 30.4745 37.8263 30.8717H36.5025C36.5555 30.5275 36.7938 30.2626 37.1909 30.2626ZM50.9845 31.1099V28.833H50.4286V30.1567C50.2432 29.9186 49.9785 29.7861 49.6343 29.7861C48.9195 29.7861 48.3635 30.3421 48.3635 31.1099C48.3635 31.8776 48.9195 32.4336 49.6343 32.4336C50.005 32.4336 50.2697 32.3013 50.4286 32.063V32.3807H50.9845V31.1099ZM48.946 31.1099C48.946 30.6598 49.2371 30.2892 49.7137 30.2892C50.1638 30.2892 50.4815 30.6334 50.4815 31.1099C50.4815 31.56 50.1638 31.9306 49.7137 31.9306C49.2371 31.904 48.946 31.56 48.946 31.1099ZM30.3602 31.1099V29.8391H29.8042V30.1567C29.6189 29.9186 29.3541 29.7861 29.0099 29.7861C28.2951 29.7861 27.7392 30.3421 27.7392 31.1099C27.7392 31.8776 28.2951 32.4336 29.0099 32.4336C29.3807 32.4336 29.6454 32.3013 29.8042 32.063V32.3807H30.3602V31.1099ZM28.2951 31.1099C28.2951 30.6598 28.5864 30.2892 29.0629 30.2892C29.513 30.2892 29.8308 30.6334 29.8308 31.1099C29.8308 31.56 29.513 31.9306 29.0629 31.9306C28.5864 31.904 28.2951 31.56 28.2951 31.1099Z"
                                                    fill="black"
                                                />
                                                <path
                                                    d="M32.875 10.5386H41.2147V25.5236H32.875V10.5386Z"
                                                    fill="#FF5F00"
                                                />
                                                <path
                                                    d="M33.4046 18.0311C33.4046 14.9865 34.8343 12.286 37.0317 10.5386C35.4168 9.26776 33.3782 8.5 31.1543 8.5C25.8855 8.5 21.623 12.7625 21.623 18.0311C21.623 23.2998 25.8855 27.5623 31.1542 27.5623C33.3781 27.5623 35.4167 26.7945 37.0317 25.5236C34.8343 23.8027 33.4046 21.0758 33.4046 18.0311Z"
                                                    fill="#EB001B"
                                                />
                                                <path
                                                    d="M52.4672 18.0311C52.4672 23.2997 48.2047 27.5623 42.9361 27.5623C40.7121 27.5623 38.6736 26.7945 37.0586 25.5236C39.2825 23.7763 40.6857 21.0758 40.6857 18.0311C40.6857 14.9865 39.256 12.286 37.0586 10.5386C38.6735 9.26776 40.7121 8.5 42.9361 8.5C48.2047 8.5 52.4672 12.789 52.4672 18.0311Z"
                                                    fill="#F79E1B"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_5104_24602">
                                                    <rect
                                                        width="30.8744"
                                                        height="24"
                                                        fill="white"
                                                        transform="translate(21.623 8.5)"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    )}
                                </div>
                            ) : (
                                <div className="flex flex-col items-center gap-9 justify-center my-16">
                                    {/* Stripe image */}
                                    <svg
                                        onClick={() => setCardType("Stripe")}
                                        className="cursor-pointer px-6 py-2 rounded-lg border-2 border-gray-300"
                                        width="170"
                                        height="74"
                                        viewBox="0 0 75 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x="0.5"
                                            y="1"
                                            width="73.0241"
                                            height="39"
                                            rx="3.5"
                                            stroke="none"
                                        />
                                        <g clip-path="url(#clip0_5104_24596)">
                                            <path
                                                d="M65.7223 20.8454C65.7223 16.7622 63.7444 13.5402 59.9643 13.5402C56.1681 13.5402 53.8713 16.7623 53.8713 20.8136C53.8713 25.6145 56.5829 28.0389 60.4746 28.0389C62.3727 28.0389 63.8083 27.6083 64.8929 27.0022V23.8121C63.8084 24.3545 62.5642 24.6895 60.9851 24.6895C59.4379 24.6895 58.0662 24.1471 57.8908 22.265H65.6905C65.6905 22.0575 65.7223 21.2282 65.7223 20.8454ZM57.8429 19.3302C57.8429 17.5278 58.9436 16.7781 59.9484 16.7781C60.9213 16.7781 61.9581 17.5278 61.9581 19.3302H57.8429ZM47.7147 13.5402C46.1514 13.5402 45.1466 14.2739 44.5884 14.7844L44.3809 13.7955H40.872V32.3932L44.8595 31.548L44.8755 27.0341C45.4497 27.4488 46.295 28.0389 47.6987 28.0389C50.5538 28.0389 53.1536 25.7421 53.1536 20.6859C53.1377 16.0603 50.5059 13.5402 47.7146 13.5402M46.7575 24.5299C45.8164 24.5299 45.2581 24.195 44.8754 23.7803L44.8594 17.8627C45.2741 17.4002 45.8483 17.0812 46.7575 17.0812C48.2089 17.0812 49.2138 18.7081 49.2138 20.7975C49.2138 22.9349 48.2249 24.5299 46.7575 24.5299ZM35.3851 12.5992L39.3886 11.7379V8.5L35.3851 9.34538V12.5992ZM35.3851 13.8114H39.3886V27.7677H35.3851V13.8114ZM31.0946 14.9917L30.8393 13.8114H27.3941V27.7677H31.3817V18.3094C32.3226 17.0812 33.9177 17.3045 34.4122 17.4799V13.8114C33.9018 13.62 32.0356 13.269 31.0946 14.9917ZM23.1194 10.3502L19.2276 11.1796L19.2117 23.9557C19.2117 26.3164 20.9822 28.0548 23.3428 28.0548C24.6507 28.0548 25.6077 27.8156 26.134 27.5285V24.2907C25.6237 24.498 23.1035 25.2317 23.1035 22.8711V17.2087H26.134V13.8114H23.1035L23.1194 10.3502ZM12.3371 17.8627C12.3371 17.2407 12.8475 17.0014 13.693 17.0014C14.9051 17.0014 16.4363 17.3683 17.6485 18.0223V14.2739C16.3247 13.7476 15.0168 13.5402 13.693 13.5402C10.455 13.5402 8.30176 15.231 8.30176 18.0542C8.30176 22.4563 14.3628 21.7546 14.3628 23.6527C14.3628 24.3863 13.7249 24.6256 12.8316 24.6256C11.5078 24.6256 9.81701 24.0833 8.47716 23.3496V27.1458C9.96056 27.7838 11.4599 28.0548 12.8316 28.0548C16.1492 28.0548 18.4301 26.4121 18.4301 23.557C18.4142 18.8039 12.3371 19.6491 12.3371 17.8627Z"
                                                fill="#635BFF"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5104_24596">
                                                <rect
                                                    width="57.4206"
                                                    height="24"
                                                    fill="white"
                                                    transform="translate(8.30176 8.5)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    {/* Visa */}
                                    <svg
                                        onClick={() => setCardType("Visa")}
                                        className="cursor-pointer px-6 py-2 rounded-lg border-2 border-gray-300"
                                        width="170"
                                        height="74"
                                        viewBox="0 0 75 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x="0.524414"
                                            y="1"
                                            width="73.0241"
                                            height="39"
                                            rx="3.5"
                                            stroke="none"
                                        />
                                        <g clip-path="url(#clip0_5104_24599)">
                                            <path
                                                d="M37.7575 17.7761C37.7336 19.8573 39.4413 21.0186 40.7277 21.7092C42.0494 22.4176 42.4933 22.8719 42.4881 23.5055C42.4783 24.4751 41.4338 24.9031 40.4565 24.9197C38.7514 24.9488 37.76 24.4126 36.9718 24.0071L36.3576 27.1731C37.1484 27.5745 38.6126 27.9246 40.131 27.9399C43.6953 27.9399 46.0271 26.0019 46.0397 22.997C46.0537 19.1834 41.2511 18.9723 41.2839 17.2677C41.2952 16.7508 41.7429 16.1993 42.724 16.059C43.2096 15.9882 44.5502 15.934 46.0701 16.7049L46.6666 13.6417C45.8492 13.3139 44.7987 12.9999 43.4908 12.9999C40.1361 12.9999 37.7765 14.9644 37.7575 17.7761ZM52.3986 13.2638C51.7478 13.2638 51.1993 13.682 50.9545 14.3237L45.8632 27.7149H49.4248L50.1336 25.5573H54.4858L54.897 27.7149H58.0361L55.2968 13.2638H52.3986ZM52.8969 17.1676L53.9247 22.5942H51.1097L52.8969 17.1676ZM33.4392 13.264L30.6318 27.7148H34.0257L36.8319 13.2636L33.4392 13.264ZM28.4184 13.264L24.8858 23.0998L23.4568 14.7365C23.2892 13.8029 22.627 13.2638 21.8917 13.2638H16.117L16.0361 13.6834C17.2216 13.9668 18.5686 14.4239 19.3846 14.9129C19.8841 15.2116 20.0265 15.4728 20.1905 16.1827L22.8971 27.7149H26.4836L31.9824 13.2638L28.4184 13.264Z"
                                                fill="url(#paint0_linear_5104_24599)"
                                            />
                                        </g>
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_5104_24599"
                                                x1="1946.94"
                                                y1="57.9096"
                                                x2="1994.57"
                                                y2="-1476.19"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stop-color="#222357" />
                                                <stop offset="1" stop-color="#254AA5" />
                                            </linearGradient>
                                            <clipPath id="clip0_5104_24599">
                                                <rect
                                                    width="42"
                                                    height="15"
                                                    fill="white"
                                                    transform="translate(16.0361 13)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                    {/* Master */}
                                    <svg
                                        onClick={() => setCardType("Mastercard")}
                                        className="cursor-pointer px-6 py-2 rounded-lg border-2 border-gray-300"
                                        width="170"
                                        height="74"
                                        viewBox="0 0 75 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect
                                            x="0.547852"
                                            y="1"
                                            width="73.0241"
                                            height="39"
                                            rx="3.5"
                                            stroke="none"
                                        />
                                        <g clip-path="url(#clip0_5104_24602)">
                                            <path
                                                d="M27.2364 32.3805V30.7921C27.2364 30.183 26.8656 29.786 26.2302 29.786C25.9125 29.786 25.5683 29.8919 25.33 30.2361C25.1447 29.9448 24.88 29.786 24.4829 29.786C24.218 29.786 23.9534 29.8654 23.7415 30.1566V29.839H23.1855V32.3805H23.7415V30.9773C23.7415 30.5274 23.9798 30.3155 24.3506 30.3155C24.7211 30.3155 24.9066 30.5538 24.9066 30.9773V32.3805H25.4625V30.9773C25.4625 30.5274 25.7271 30.3155 26.0713 30.3155C26.4421 30.3155 26.6273 30.5538 26.6273 30.9773V32.3805H27.2364ZM35.47 29.839H34.57V29.0712H34.014V29.839H33.511V30.3419H34.0139V31.5069C34.0139 32.0894 34.2522 32.4335 34.8877 32.4335C35.126 32.4335 35.3906 32.3541 35.5761 32.2482L35.4171 31.7716C35.2583 31.8775 35.073 31.904 34.9406 31.904C34.6759 31.904 34.57 31.7452 34.57 31.4804V30.3419H35.47V29.839ZM40.1827 29.7859C39.8651 29.7859 39.6533 29.9448 39.5209 30.1566V29.839H38.9649V32.3805H39.5209V30.9509C39.5209 30.5274 39.7061 30.289 40.0503 30.289C40.1562 30.289 40.2886 30.3156 40.3945 30.342L40.5533 29.8125C40.4475 29.786 40.2886 29.786 40.1827 29.786M33.0609 30.0509C32.796 29.8655 32.4254 29.7861 32.0283 29.7861C31.3929 29.7861 30.9694 30.1038 30.9694 30.6068C30.9694 31.0305 31.2871 31.2687 31.843 31.3482L32.1078 31.3747C32.399 31.4275 32.5578 31.507 32.5578 31.6394C32.5578 31.8247 32.3461 31.9571 31.9753 31.9571C31.6046 31.9571 31.3135 31.8247 31.1281 31.6924L30.8634 32.1159C31.1546 32.3277 31.5518 32.4336 31.9488 32.4336C32.6902 32.4336 33.1138 32.0895 33.1138 31.6129C33.1138 31.1628 32.7696 30.9245 32.2401 30.8451L31.9753 30.8186C31.737 30.7921 31.5518 30.7393 31.5518 30.5804C31.5518 30.3951 31.737 30.2892 32.0283 30.2892C32.3461 30.2892 32.6637 30.4215 32.8226 30.5009L33.0609 30.0509ZM47.8342 29.7861C47.5164 29.7861 47.3046 29.945 47.1722 30.1567V29.8391H46.6162V32.3807H47.1722V30.951C47.1722 30.5275 47.3575 30.2892 47.7016 30.2892C47.8076 30.2892 47.94 30.3157 48.0459 30.3421L48.2048 29.8127C48.0989 29.7861 47.94 29.7861 47.8342 29.7861ZM40.7387 31.1099C40.7387 31.8776 41.2682 32.4336 42.089 32.4336C42.4596 32.4336 42.7243 32.3543 42.989 32.1425L42.7243 31.6924C42.5125 31.8512 42.3008 31.9306 42.0625 31.9306C41.6124 31.9306 41.2947 31.6129 41.2947 31.1099C41.2947 30.6334 41.6124 30.3156 42.0625 30.2892C42.3008 30.2892 42.5125 30.3685 42.7243 30.5275L42.989 30.0774C42.7243 29.8655 42.4596 29.7861 42.089 29.7861C41.2682 29.7861 40.7387 30.3421 40.7387 31.1099ZM45.875 31.1099V29.8391H45.319V30.1567C45.1336 29.9186 44.8689 29.7861 44.5247 29.7861C43.8099 29.7861 43.2539 30.3421 43.2539 31.1099C43.2539 31.8776 43.8099 32.4336 44.5247 32.4336C44.8953 32.4336 45.1601 32.3013 45.319 32.063V32.3807H45.875V31.1099ZM43.8363 31.1099C43.8363 30.6598 44.1275 30.2892 44.604 30.2892C45.0541 30.2892 45.3719 30.6334 45.3719 31.1099C45.3719 31.56 45.0541 31.9306 44.604 31.9306C44.1275 31.904 43.8363 31.56 43.8363 31.1099ZM37.1911 29.7861C36.4497 29.7861 35.9201 30.3156 35.9201 31.1099C35.9201 31.9042 36.4496 32.4336 37.2175 32.4336C37.5881 32.4336 37.9588 32.3277 38.2501 32.0895L37.9852 31.6924C37.7734 31.8512 37.5087 31.9571 37.244 31.9571C36.8998 31.9571 36.5556 31.7983 36.4761 31.3481H38.356V31.1364C38.3825 30.3156 37.906 29.7861 37.1911 29.7861ZM37.1909 30.2626C37.535 30.2626 37.7734 30.4745 37.8263 30.8717H36.5025C36.5555 30.5275 36.7938 30.2626 37.1909 30.2626ZM50.9845 31.1099V28.833H50.4286V30.1567C50.2432 29.9186 49.9785 29.7861 49.6343 29.7861C48.9195 29.7861 48.3635 30.3421 48.3635 31.1099C48.3635 31.8776 48.9195 32.4336 49.6343 32.4336C50.005 32.4336 50.2697 32.3013 50.4286 32.063V32.3807H50.9845V31.1099ZM48.946 31.1099C48.946 30.6598 49.2371 30.2892 49.7137 30.2892C50.1638 30.2892 50.4815 30.6334 50.4815 31.1099C50.4815 31.56 50.1638 31.9306 49.7137 31.9306C49.2371 31.904 48.946 31.56 48.946 31.1099ZM30.3602 31.1099V29.8391H29.8042V30.1567C29.6189 29.9186 29.3541 29.7861 29.0099 29.7861C28.2951 29.7861 27.7392 30.3421 27.7392 31.1099C27.7392 31.8776 28.2951 32.4336 29.0099 32.4336C29.3807 32.4336 29.6454 32.3013 29.8042 32.063V32.3807H30.3602V31.1099ZM28.2951 31.1099C28.2951 30.6598 28.5864 30.2892 29.0629 30.2892C29.513 30.2892 29.8308 30.6334 29.8308 31.1099C29.8308 31.56 29.513 31.9306 29.0629 31.9306C28.5864 31.904 28.2951 31.56 28.2951 31.1099Z"
                                                fill="black"
                                            />
                                            <path
                                                d="M32.875 10.5386H41.2147V25.5236H32.875V10.5386Z"
                                                fill="#FF5F00"
                                            />
                                            <path
                                                d="M33.4046 18.0311C33.4046 14.9865 34.8343 12.286 37.0317 10.5386C35.4168 9.26776 33.3782 8.5 31.1543 8.5C25.8855 8.5 21.623 12.7625 21.623 18.0311C21.623 23.2998 25.8855 27.5623 31.1542 27.5623C33.3781 27.5623 35.4167 26.7945 37.0317 25.5236C34.8343 23.8027 33.4046 21.0758 33.4046 18.0311Z"
                                                fill="#EB001B"
                                            />
                                            <path
                                                d="M52.4672 18.0311C52.4672 23.2997 48.2047 27.5623 42.9361 27.5623C40.7121 27.5623 38.6736 26.7945 37.0586 25.5236C39.2825 23.7763 40.6857 21.0758 40.6857 18.0311C40.6857 14.9865 39.256 12.286 37.0586 10.5386C38.6735 9.26776 40.7121 8.5 42.9361 8.5C48.2047 8.5 52.4672 12.789 52.4672 18.0311Z"
                                                fill="#F79E1B"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5104_24602">
                                                <rect
                                                    width="30.8744"
                                                    height="24"
                                                    fill="white"
                                                    transform="translate(21.623 8.5)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            )}

                            {/* Full Name Field */}
                            <div className="w-full">
                                {cardType === "Stripe" && (
                                    <>
                                        <div className="text-[#4B5563] font-bold text-sm">
                                            Login to your Stripe Account
                                        </div>
                                        <div className="flex flex-col gap-3 mt-2">
                                            <div className="relative">
                                                <BsEnvelope
                                                    size={16}
                                                    className="absolute top-3.5 left-3.5 text-gray-500"
                                                />
                                                <input
                                                    type="email"
                                                    placeholder="Email"
                                                    className="w-full border border-gray-300 text-sm pl-10 pr-2 py-3 rounded-md focus:outline-none focus:border-blue-500"
                                                />
                                            </div>
                                            <div className="relative">
                                                <LiaKeySolid
                                                    size={16}
                                                    className="absolute top-3.5 left-3.5 text-gray-500"
                                                />
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    className="w-full border border-gray-300 text-sm pl-10 pr-10 py-3 rounded-md focus:outline-none focus:border-blue-500"
                                                />
                                                <div
                                                    className="absolute top-3.5 right-3.5 cursor-pointer text-gray-500"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? (
                                                        <AiFillEyeInvisible size={16} />
                                                    ) : (
                                                        <AiFillEye size={16} />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <button className="w-full mt-4 py-3 bg-blue-900 rounded-full text-white">
                                            Login
                                        </button>
                                        <p className="mt-5 text-center text-[#5F5F5F] cursor-pointer text-[12px]">
                                            Forgot Password?
                                        </p>
                                        <div className="font-semibold mt-4 text-[#6B7280] text-sm text-center cursor-pointer">
                                            Create a Stripe Account
                                        </div>
                                    </>
                                )}

                                {(cardType === "Visa" ||
                                    cardType === "Mastercard" ||
                                    cardType === "American Express" ||
                                    cardType === "Discover" ||
                                    cardType === "JCB" ||
                                    cardType === "Diners Club" ||
                                    cardType === "UnionPay" ||
                                    cardType === "Unknown Card Type") && (
                                        <div>
                                            {/* <CardElement options={CARD_ELEMENT_OPTIONS} className="StripeElement my-6" /> */}
                                            <div className="StripeElement mb-4">
                                                <label>Card Number</label>
                                                <CardNumberElement
                                                    options={CARD_ELEMENT_OPTIONS}
                                                    className="w-full border border-gray-300 px-2 py-3 rounded-md focus:outline-none focus:border-blue-500"
                                                    placeholder="Card Number"
                                                    onChange={handleCardChange}
                                                />
                                            </div>
                                            <div className="StripeElement mb-4">
                                                <label>Name on Card</label>
                                                <input
                                                    id="fullName"
                                                    type="text"
                                                    placeholder="Card Holder"
                                                    className="w-full border border-gray-300 px-2 py-[9.4px] rounded-md focus:outline-none focus:border-gray-300"
                                                    value={cardHolder}
                                                    onChange={(e) => setCardHolder(e.target.value)}
                                                />
                                            </div>
                                            <div className="flex flex-col md:flex-row justify-between md:gap-3">
                                                <div className="StripeElement mb-4 flex-grow w-full">
                                                    <label>Expiry Date</label>
                                                    <CardExpiryElement
                                                        options={CARD_ELEMENT_OPTIONS}
                                                        className="w-full border border-gray-300 px-2 py-3 rounded-md focus:outline-none focus:border-blue-500"
                                                    />
                                                </div>
                                                <div className="StripeElement mb-4 flex-grow w-full">
                                                    <label>CVC</label>
                                                    <CardCvcElement
                                                        options={CARD_ELEMENT_OPTIONS}
                                                        className="w-full border border-gray-300 px-2 py-3 rounded-md focus:outline-none focus:border-blue-500"
                                                    />
                                                </div>
                                                <div className="StripeElement mb-4 flex-grow w-full">
                                                    <label>ZIP Code</label>
                                                    <input
                                                        type="text"
                                                        className="w-full border border-gray-300 px-2 py-[9.4px] rounded-md focus:outline-none focus:border-gray-300"
                                                        placeholder="ZIP Code"
                                                        onChange={(e) => setZipCode(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div id="card-errors" role="alert">
                                                {errorMessage &&
                                                    errorMessage === "Your card number is invalid." && (
                                                        <small className="text-red-500">{errorMessage}</small>
                                                    )}
                                            </div>
                                            {errorMessage &&
                                                errorMessage !== "Your card number is invalid." && (
                                                    <small className="text-red-500 text-sm flex justify-center text-center mt-2">
                                                        {errorMessage.includes(".")
                                                            ? errorMessage.split(".")[0]
                                                            : errorMessage}
                                                    </small>
                                                )}
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>

                    <div className="py-6 lg:w-[60%] bg-white min-h-[450px] border-t lg:border-t-0 lg:border-l border-gray-200 rounded-b-lg lg:rounded-b-none lg:rounded-tr-2xl lg:rounded-br-2xl">
                        <div className="px-4 sm:px-6 lg:px-8 max-md:px-0">
                            <div className="flex lg:flex-row justify-between items-center">
                                <div className="font-bold text-[#1c3775] text-lg lg:text-xl">
                                    Order Summary
                                </div>
                                <div className="flex items-center text-neutral-500 lg:mt-0">
                                    <FaCoins className="mr-2 text-yellow-500" />
                                    <div className="font-bold">
                                        {membershipCountryValues.currencyName}
                                    </div>
                                </div>
                            </div>

                            <div className="flex lg:flex-row justify-between mt-4">
                                <div className="font-medium text-neutral-600">Sign-Up Fee</div>
                                <div className="font-bold text-lg text-neutral-800 mt-4 lg:mt-0">
                                    {membershipCountryValues.currencySymbol}
                                    {membershipCountryValues.membershipFeeForDisplay.toFixed(2)}
                                </div>
                            </div>

                            <div className="flex lg:flex-row justify-between mt-3">
                                <div>
                                    <div className="font-medium text-neutral-600">
                                        Annual Subscription Fee
                                    </div>
                                    <div className="relative group cursor-pointer">
                                        <span className="text-[#9CA3AF] text-sm">
                                            You will be charged{" "}
                                            {membershipCountryValues.currencySymbol}
                                            {parseFloat(
                                                membershipCountryValues.membershipRenewalFee
                                            ).toFixed(2)}{" "}
                                            next year (01/15/2025)
                                        </span>
                                    </div>
                                </div>
                                <div className="font-bold text-lg text-neutral-800 mt-4 lg:mt-0">
                                    $0
                                </div>
                            </div>

                            <hr className="mt-5" />

                            <div className="mt-4">
                                <div className="font-medium text-neutral-600">
                                    Coupon Code / Access Key
                                </div>
                                <div className="flex flex-col lg:flex-row items-start lg:items-center mt-2">
                                    <input
                                        type="text"
                                        className="flex-1 px-4 py-3 border rounded-lg border-neutral-300 max-md:w-full"
                                        placeholder="Coupon Code"
                                        value={coupon}
                                        onChange={(e) => {
                                            setCoupon(e.target.value);
                                        }}
                                    />
                                    <button
                                        onClick={handleValidateCoupon}
                                        className="mt-4 lg:mt-0 lg:ml-4 bg-[#1c3775] text-white px-8 py-3 rounded-full font-normal w-full lg:w-auto"
                                    >
                                        Apply
                                    </button>
                                </div>
                                {couponStates.loading && (
                                    <p className="mt-1 text-blue-900 text-sm">
                                        Validating coupon...
                                    </p>
                                )}
                                {couponStates.error && !couponStates.loading && (
                                    <p className="mt-1 text-red-900 text-sm">
                                        {couponStates.message}
                                    </p>
                                )}
                            </div>

                            {accessKeyDiscount > 0 && (
                                <div className="flex justify-between mt-2 mb-4 max-md:mt-4 max-md:text-sm">
                                    <div className="font-medium text-neutral-600">{`Access Key Discount`}</div>
                                    <div className="text-neutral-600">
                                        -{membershipCountryValues.currencySymbol}
                                        {(
                                            membershipCountryValues.membershipFeeForComputation *
                                            accessKeyDiscount
                                        ).toFixed(2)}
                                    </div>
                                </div>
                            )}

                            <hr className="mt-5" />

                            <div className="flex justify-between mt-4 text-lg font-bold">
                                <div>Total Amount</div>
                                <div>
                                    <FormattedNumber
                                        value={
                                            membershipCountryValues.membershipFeeForComputation -
                                            (
                                                membershipCountryValues.membershipFeeForComputation *
                                                accessKeyDiscount
                                            ).toFixed(2)
                                        }
                                        style="currency"
                                        currency={membershipCountryValues.currencyName || "USD"}
                                    />
                                </div>
                            </div>

                            <button
                                onClick={handleSubmit}
                                disabled={isPayNowDisabled}
                                className={`w-full mt-4 ${isPayNowDisabled
                                    ? "bg-gray-400 cursor-not-allowed"
                                    : "bg-[#1c3775]"
                                    } text-white px-7 py-3 rounded-full font-normal text-lg`}
                            >
                                Pay Now
                            </button>

                            {auth.loading && (
                                <p className="mt-2 text-blue-900 text-sm">Processing...</p>
                            )}
                            {auth.error && (
                                <p className="mt-2 text-red-900 text-sm">{auth.error}</p>
                            )}

                            <div className="flex items-center mt-6 text-neutral-500">
                                <FaLock className="text-2xl" />
                                <div className="ml-3 text-sm">
                                    <span className="font-bold">Secure checkout. </span>
                                    For your convenience, we will save your encrypted payment
                                    information for future payments.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showConfirmation && (
                    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                        <div className="bg-white rounded-lg shadow-lg p-8 w-11/12 md:w-3/4 lg:w-2/3 xl:w-1/2 mx-auto">
                            <h2 className="text-xl font-bold mb-4">Confirm Payment</h2>
                            <p>Are you sure you want to proceed with the payment?</p>
                            <div className="mt-6 flex justify-end gap-4">
                                <button
                                    onClick={() => setShowConfirmation(false)}
                                    className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handlConfirmPayment}
                                    className="bg-green-500 text-white px-4 py-2 rounded-lg"
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StripePayment;
